import { Component, OnInit } from '@angular/core';

import { MatterType } from '../../../models/matter-type';

@Component({
  selector: 'app-matter-type-new',
  templateUrl: './matter-type-new.component.html',
  styleUrls: ['./matter-type-new.component.css'],
})
export class MatterTypeNewComponent implements OnInit {
  matterType: MatterType = new MatterType();

  constructor() {}

  ngOnInit() {}
}
